module.exports = __webpack_public_path__ + "static/media/box-active.a84614ee.svg";